import React from 'react';
import _ from 'lodash';
import { Button } from '@mui/material';
import { handleShowOn } from '../../services/functions';

export const ButtonField = props => {
  const { field, formik, getFieldCallback } = props;
  const handleChange = e => {
    if (field.on_change == 'getGuardianDataFunction') {
      if (formik.values.different_address) {
        formik.setFieldValue('contractor_street_address', formik.values.guardian_street_address);
        formik.setFieldValue('contractor_city', formik.values.guardian_city);
        formik.setFieldValue('contractor_postal_code', formik.values.guardian_postal_code);
        formik.setFieldValue('contractor_voivodeship', formik.values.guardian_province);

      } else {
        formik.setFieldValue('contractor_street_address', formik.values.participant_street_address);
        formik.setFieldValue('contractor_city', formik.values.participant_city);
        formik.setFieldValue('contractor_postal_code', formik.values.participant_postal_code);
        formik.setFieldValue('contractor_voivodeship', formik.values.participant_province);
      }
    }
    if (field.on_change == 'getSchoolDataFunction') {
      formik.setFieldValue('contractor_name', formik.values.school_name);
      formik.setFieldValue('contractor_nip', formik.values.school_nip);
      formik.setFieldValue('contractor_street_address', formik.values.school_street_address);
      formik.setFieldValue('contractor_city', formik.values.school_city);
      formik.setFieldValue('contractor_postal_code', formik.values.school_postal_code);
      formik.setFieldValue('contractor_voivodeship', formik.values.school_province);
    }
    if (field.on_change == 'getOnlyGuardianDataFunction') {
      formik.setFieldValue('contractor_street_address', formik.values.guardian_street_address);
      formik.setFieldValue('contractor_city', formik.values.guardian_city);
      formik.setFieldValue('contractor_postal_code', formik.values.guardian_postal_code);
      formik.setFieldValue('contractor_voivodeship', formik.values.guardian_province);
    }
  };

  return (
    <Button style={{ display: handleShowOn(
      field.show_on, formik.values,
      getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []))
      ? ''
      : 'none' }} variant="contained" onClick={e => handleChange(e)}>{field.label}</Button>
  );
};
